export enum Kind {
  DEFAULT = 'DEFAULT',
  PRIMARY = 'PRIMARY',
  PRIMARY_DARK = 'PRIMARY_DARK',
  PRIMARY_MUTED = 'PRIMARY_MUTED',
  SECONDARY_SUCCESS = 'SECONDARY_SUCCESS',
  SECONDARY = 'SECONDARY',
  LIGHT = 'LIGHT',
  LIGHT_SUCCESS = 'LIGHT_SUCCESS',
}
